import { wxShareConfig } from "@API";
import baseConfig from "@BaseConfig";
const { iosMarketUrl, androidMarketScheme, androidMarketUrl,
  goartAndroidMarketUrl, goartAndroidMarketScheme, goartiOSMarketUrl,
  clipflyAndroidMarketUrl, clipflyAndroidMarketScheme, clipflyIosMarketUrl } = baseConfig;
import Cookies from "js-cookie";
import { sensorsTrack } from "./sensors";

export const isProd = process.env.APP_ENV === "production";
export const isDev = process.env.APP_ENV === "development";

export function setUserCookie(token: string) {
  Cookies.set('credential', token, { expires: 30 });
}

export function sleep(ms: number) {
  return new Promise(r => setTimeout(r, ms));
}
/**
 * 使用友盟的 ULink 打开 APP
 * @param linkID
 * @param schema
 */
export function openInAppByUlinkID(linkID: string, schema?: string) {
  ULink([
    {
      id: linkID,
      data: {
        schema
      },
      auto: true, // 加载后会尝试唤起App
      lazy: true, // 加载后立刻计入活动触发次数
      // selector: "#"+linkID,

      useOpenInBrowerTips: "default",
      useClipboard: function(token: string) {
        copyTextIntoClipboard(token);
      },
      proxyOpenDownload: function(defaultAction: any, LinkInstance: any) {
        if (LinkInstance.solution.type === "scheme") {
          // qq或者微信环境特殊处理下
          if (ULink.isWechat || ULink.isQQ) {
            // 在qq或者微信环境执行内置逻辑，具体内置逻辑为:当设置了useOpenInBrowerTips字段时，qq&&微信&&scheme时，启用蒙层提示去浏览器打开
            defaultAction();
          } else {
            window.location.href = LinkInstance.solution.downloadUrl;
          }
        } else if (LinkInstance.solution.type === "universalLink") {
          // universalLink 唤起应当由服务端提供一个带重定向到appstore的universallink地址。因此，此处不应写逻辑，友盟已于6月2日上线universalLink生成及重定向功能。
        }
      }
    }
  ]);
}

export function getUserToken() {
  //credential 注册用户token；touristCredential 游客token
  return getCookie("credential") || getCookie("touristCredential");
}

export function getCookie(_key: string) {
  if (process.server) return "";
  const _strCookie = document.cookie;
  const _arrCookie = _strCookie.split("; ");
  for (let i = 0; i < _arrCookie.length; i++) {
    const _arr = _arrCookie[i].split("=");
    if (_arr[0] === _key) {
      return _arr[1];
    }
  }
  return "";
}

// 设置页面元素最小高度为屏幕高度,有时需要设置页面背景色，所以需要元素高度至少为屏幕高度，不然颜色无法覆盖全屏
export function setMinHeight(ele: HTMLElement) {
  try {
    const clientHeight = document.documentElement.clientHeight;
    if (clientHeight > 0) {
      ele.style.minHeight = document.documentElement.clientHeight + "px";
    } else {
      // android app webview clientHeight值很大概率获取为0
      ele.style.minHeight = "100vh";
    }
    return true;
  } catch (e) {
    return false;
  }
}


// 获取终端信息
export function getBrowser() {
  if (process.client) {
    const u = navigator.userAgent.toLowerCase();
    // 检测是否为三星平板 Chrome 浏览器
    const isSamsungChrome = u.includes("linux") &&
                           u.includes("chrome") &&
                           navigator.maxTouchPoints > 0 &&
                           !u.includes("mobile");

    const isAndroid = u.includes("android") ||
                     u.includes("adr") ||
                     u.includes("samsungbrowser") ||
                     isSamsungChrome;

    // 检测iOS设备（包括桌面模式的iPad）
    let isiOS = /iphone|ipad|ipod|ios/i.test(u) || !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);

    // 桌面模式iPad检测：通过多种特征综合判断
    const isPossibleDesktopIPad = u.includes("macintosh") &&
      u.includes("safari") &&
      !u.includes("chrome") &&
      navigator.maxTouchPoints > 0;

    if (isPossibleDesktopIPad) {
      isiOS = true;
    }

    // 移动设备检测（包括传统iPad和三星设备）
    const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|SamsungBrowser/i.test(u) ||
      (u.includes("ipad")) ||
      isPossibleDesktopIPad ||
      isSamsungChrome;

    // Safari检测（排除Chrome内核浏览器）
    const isSafari = u.includes("safari") && !u.includes("chrome") && !u.includes("android");

    const isQQ = u.includes("qq");
    const wechatMath = u.match(/MicroMessenger/i);
    const weiboMath = u.match(/WeiBo/i);
    const isBytedance = u.includes("bytedance");
    const isWechat =
      (wechatMath ? wechatMath.includes("micromessenger") : false) ||
      (weiboMath ? weiboMath.includes("weibo") : false);

    // PC检测（排除所有移动设备，包括桌面模式iPad和三星平板）
    const isPC = !u.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|SamsungBrowser)/i
    ) && !isPossibleDesktopIPad && !isSamsungChrome;

    return {
      isMobile,
      isAndroid,
      isiOS,
      isQQ,
      isPC,
      isWechat,
      isSafari,
      isBytedance,
    };
  }
  // 服务器端返回默认值
  return {
    isMobile: false,
    isAndroid: false,
    isiOS: false,
    isQQ: false,
    isPC: true,
    isWechat: false,
    isSafari: false,
    isBytedance: false,
  };
}

export function getFotorXAppId() {
  const { isiOS } = getBrowser();
  return isiOS ? "app-fotor-ios" : "app-fotor-android"
}

export function getGoArtXAppId() {
  const { isiOS } = getBrowser();
  return isiOS ? "app-goart-ios" : "app-goart-android"
}

export function autoGetXAppId() {
  if (process.client) {
    isInGoArtAppBrower() ? getGoArtXAppId() : getFotorXAppId()
  }
  return getFotorXAppId()
}

export function downloadAppFunc(platform: string, newWindow: boolean, google_store_referrer?: string, app_name?: string) {
  const { isAndroid, isiOS, isWechat, isPC } = getBrowser();
  let href = "";
  let googleScheme = androidMarketScheme;
  let googleHttps = androidMarketUrl;
  let iosUrl = iosMarketUrl
  if (app_name === "clipfly") {
    console.log('=======>处理clipfly下载')
    googleScheme = clipflyAndroidMarketScheme;
    googleHttps = clipflyAndroidMarketUrl;
    iosUrl = clipflyIosMarketUrl;
  }
  //google应用商店连接拼上 referrer 参数
  if (google_store_referrer) {
    googleScheme += ('&referrer=' + google_store_referrer);
    googleHttps += ('&referrer=' + google_store_referrer);
  }
  /*
  微信内访问
  iOS &Android 点击"下载"，跳转至应用宝"像素蜜蜂"下载页
  浏览器访问
  iOS 点击"下载"，跳转 AppStore "像素蜜蜂"详情界面
  Android 点击"下载"，启动到应用商店"像素蜜蜂"详情界面（market跳转逻辑）
  检测到多个应用商店，则由系统弹出应用商店列表供用户选择
  3秒后没有跳转，则用浏览器打开 apk 下载地址进行下载
  * */
  if (isWechat) {
    href = isAndroid ? googleScheme : iosUrl;
  } else if (platform) {
    if (platform === "android") {
      href = googleScheme;
    } else {
      href = iosUrl;
    }
  } else if (isAndroid) {
    href = googleScheme;
  } else if (isiOS) {
      href = iosUrl;
  } else {
    href = googleHttps;
  }
  if (newWindow) {
    window.open(href);
  } else {
    console.log('downloadAppFunc 转到-----', href);
    location.href = href;
  }
  if (!isPC && !isWechat && isAndroid) {
    const id = setTimeout(function() {
      window.location.href = googleHttps;
    }, 3000);
    document.addEventListener(
      "visibilitychange",
      function run() {
        document.removeEventListener("visibilitychange", run, false);
        clearTimeout(id);
      },
      false
    );
  }
}
/*
* 打开app
*
iOS 点击"APP内打开"，跳转至 "像素蜜蜂" App 并打开该页面；（需要 APP 配合支持，更新版本）
iOS 9 及以上；
无法正常跳转时，跳转至应用宝"像素蜜蜂"下载页；
Android 点击"APP内打开"，弹出引导使用浏览器打开提示浮层；
使用浏览器打开后，点击"APP内打开"，跳转至 "像素蜜蜂" App 并打开该页面；
无法正常跳转时，跳转至"像素蜜蜂"下载页（部分浏览器无法正常跳转）；
"下载"相关，同上；
引导使用浏览器打开提示，改为浮层和样式调整；
浏览器访问
 iOS &Android 点击"APP内打开"，跳转至 "像素蜜蜂" App 并打开该页面；
无法正常跳转时，跳转至"像素蜜蜂"下载页（部分浏览器无法正常跳转）；
"下载"相关，同上；
* */
interface IOpenAppParams {
  schema?: string;
  showGuide?: Function;
}
export function openApp(app: object, params: IOpenAppParams, client = getBrowser()) {
  const { isAndroid, isWechat } = client;
  if (typeof app !== "object") {
    return;
  }
  params.schema = params.schema || "fotor://";
  if (isWechat && params.showGuide) {
    // if (isiOS) {
    //   location.href = downloadAppPage + "?applicationOfTreasure=true&furl=" + encodeURIComponent(params.schema);
    // } else if (typeof params.showGuide === "function") {
    // 这个传递一个显示微信引导浏览器打开遮罩的方法进来
    // @ts-ignore
    params.showGuide();
    // }
  } else if (isAndroid) {
    setTimeout(() => {
      if (params.schema != null) {
        location.href = params.schema;
      }
    }, 0)
    const id = setTimeout(function() {
      location.href = wrapSchema(params.schema || "fotor://");
    }, 3000);
    document.addEventListener(
      "visibilitychange",
      function run() {
        document.removeEventListener("visibilitychange", run, false);
        clearTimeout(id);
      },
      false
    );
  }
  //否则是 iOS
  else {
    location.href = wrapSchema(params.schema || "fotor://");
  }
}

export function goartDownloadApp() {
  const { isiOS, isWechat } = getBrowser();
  let href = isiOS ? goartiOSMarketUrl : goartAndroidMarketUrl;
  window.location.href = href;//转到应用市场
}

export function goartOpenApp(params: IOpenAppParams = {}, client = getBrowser()) {
  const { isiOS, isWechat, isAndroid } = client;
  params.schema = params.schema || "goart://";
  //iOS使用通用链接打开app
  let iosUls = process.env.GOART_IOS_UNIVERSAL_LINKS + "?furl=" + encodeURIComponent(params.schema);
  if (isWechat && params.showGuide) {
    if (isiOS) {
      location.href = iosUls
    } else {
      params.showGuide();
    }
  } else if (isAndroid) {
    setTimeout(() => {
      if (params.schema != null) {
        location.href = params.schema;
      }
    }, 0)
    const id = setTimeout(function() {
      let href = isiOS ? goartiOSMarketUrl : goartAndroidMarketUrl;
      window.location.href = href;//转到应用市场
    }, 3000);
    document.addEventListener(
      "visibilitychange",
      function run() {
        document.removeEventListener("visibilitychange", run, false);
        clearTimeout(id);
      },
      false
    );
  }
  else {
    location.href = iosUls;// 使用通用链接不在会自动打开应用商店，需要转到下载页自行点击
  }
}

/*
 * 封装schema,使之能够在浏览器和app跳转页面
 * @param schema   app schema
 * */
export function wrapSchema(schema: string) {
  if (isInAppBrower()) {
    return schema; //app内直接打开 schema
  } else {
    //app外使用 苹果通用链接打开 schema
    return process.env.IOS_UNIVERSAL_LINKS + "/?furl=" + encodeURIComponent(schema);
  }
}

// 是否是内置app浏览器(旧的判断机制是cookie中 PixbeInnerBrowser=true,
// 新的判断机制是userAgent中判断)
// 必须要缓存，不然app内有问题（比如网页中新开webview后回退回来的时候可能会丢失信息）
export function isInAppBrower() {
  if (!window.__isInFotorAppBrower) {
    window.__isInFotorAppBrower = getCookie("FotorInnerBrowser") === "true";
  }
  return window.__isInFotorAppBrower;
}

//是否在 GoArt App 内
export function isInGoArtAppBrower() {
  if (!window.__isInGoArtAppBrower) {
    window.__isInGoArtAppBrower = getCookie("GoArtInnerBrowser") === "true";
  }
  return window.__isInGoArtAppBrower;
}

//是否在 ClipFly App 内
export function isInClipFlyAppBrower() {
  if (!window.__isInClipFlyAppBrower) {
    window.__isInClipFlyAppBrower = getCookie("ClipFlyInnerBrowser") === "true";
  }
  return window.__isInClipFlyAppBrower;
}



// 获取客户端app相关信息
// 必须要缓存，不然app内有问题（比如网页中新开webview后回退回来的时候可能会丢失信息）
export function getClientInfo() {
  if (!window.__fotorClientInfo) {
    const userAgent = navigator.userAgent;
    const regexp = /Fotor\/(\d+.\d+.\d+(?:.\d+)*)\s+\(([^\s]*);\s+.*;.*\)/;
    const result = regexp.exec(userAgent);
    if (result) {
      window.__fotorClientInfo = {
        appVersion: result[1],
        client: result[2]
      };
    } else {
      window.__fotorClientInfo = {};
    }
  }
  return window.__fotorClientInfo;
}

//获取goart客户端app相关信息
export function getGoArtClientInfo() {
  if (!window.__goartClientInfo) {
    const userAgent = navigator.userAgent;
    const regexp = /GoArt\/(\d+.\d+.\d+(?:.\d+)*)\s+\(([^\s]*);\s+.*;.*\)/;
    const result = regexp.exec(userAgent);
    if (result) {
      window.__goartClientInfo = {
        appVersion: result[1],
        client: result[2]
      };
    } else {
      window.__goartClientInfo = {};
    }
  } else {
    console.log('已存在 __goartClientInfo', window.__goartClientInfo)
  }
  return window.__goartClientInfo;
}


export function getClipFlyClientInfo() {
  if (!window.__clipflyClientInfo) {
    const userAgent = navigator.userAgent;
    const regexp = /ClipFly\/(\d+.\d+.\d+(?:.\d+)*)\s+\(([^\s]*);\s+.*;.*\)/;
    const result = regexp.exec(userAgent);
    if (result) {
      window.__clipflyClientInfo = {
        appVersion: result[1],
        client: result[2]
      };
    } else {
      window.__clipflyClientInfo = {};
    }
  } else {
    console.log('已存在 __clipflyClientInfo', window.__clipflyClientInfo)
  }
  return window.__clipflyClientInfo;
}



export function getHref() {
  return location.protocol + "//" + location.host;
}

export function copyTextIntoClipboard(value: string) {
  const el = document.createElement("textarea");
  el.value = value;
  document.body.appendChild(el);
  el.select();
  el.setSelectionRange(0, 99999);
  const status = document.execCommand("copy");
  document.body.removeChild(el);

  return status;
}

// 设置网页title
export function setNavTitle(title: string | undefined) {
  try {
    let { appVersion } = getClientInfo();
    appVersion = appVersion || "0";
    // 设置title的接口要求app版本 >= 1.0.0
    if (isInAppBrower() && compareVersion(appVersion, "1.0.0") >= 0) {
      const { isAndroid } = getBrowser();
      if (isAndroid) {
        //@ts-ignore
        window.fotorJSHandler.setNaviTitle(title);
      } else {
        // ios
        window.webkit.messageHandlers.setNaviTitle.postMessage(title);
      }
    }
  } catch (e) {
    // some error caught
  }
}


export function goArtSDK(func: string, params?: string) {
  if (process.env.NODE_ENV === "development") {
    console.log("goArtSDK", func, params) // 参数可能包含 base64, 不打印
  }
  try {
    if (isInGoArtAppBrower()) {
      const { isAndroid } = getBrowser();
      if (isAndroid) {
        window.goartJSHandler[func](params);
      } else {
        // ios
        window.webkit.messageHandlers[func].postMessage(params);
      }
    } else {
      console.log('检测到不在APP内')
    }
  } catch (e) {
    console.error('调用原生app函数失败', e, func, params)
  }
}

export function fotorSDK(func: string, params?: string) {
  if (process.env.NODE_ENV === "development") {
    console.log("fotorSDK", func, params) // 参数可能包含 base64, 不打印
  }
  try {
    if (isInAppBrower()) {
      const { isAndroid } = getBrowser();
      if (isAndroid) {
        window.fotorJSHandler[func](params);
      } else {
        // ios
        window.webkit.messageHandlers[func].postMessage(params);
      }
    } else {
      console.log('检测到不在APP内')
    }
  } catch (e) {
    console.error('调用原生app函数失败', e, func, params)
  }
}


export function clipflySDK(func: string, params?: string) {
  if (process.env.NODE_ENV === "development") {
    console.log("clipflySDK", func, params) // 参数可能包含 base64, 不打印
  }
  try {
    if (isInClipFlyAppBrower()) {
      const { isAndroid } = getBrowser();
      if (isAndroid) {
        window.clipflyJSHandler[func](params);
      } else {
        // ios
        window.webkit.messageHandlers[func].postMessage(params);
      }
    }
  } catch (e) {
    console.error('调用原生app函数失败', e, func, params)
  }
}






// GoArt SDK 更新用户订阅状态
export function updateSubscribeStateSDK() {
  goArtSDK("updateSubscribeState")
}

/**
 * GoArt SDK 通用分享
 * @param {Object} data {
  "type": 0,
  "data": {
    "title": "分享的标题, string",
    "description": "分享的描述, string",
    "icon": "分享的图片地址, string",
    "url": "分享的网页地址, string"
  }
}
 */
export function goartShareWithInfo(data: any) {
  Object.keys(data.data).forEach((key) => (data.data[key] == null) && delete data.data[key]);
  goArtSDK("shareWithInfo", JSON.stringify(data));
}

/**
 * Fotor SDK 通用分享
 * @param {Object} data {
  "type": 0,
  "data": {
    "title": "分享的标题, string",
    "description": "分享的描述, string",
    "icon": "分享的图片地址, string",
    "url": "分享的网页地址, string"
  }
} */
export function fotorShareWithInfo(data: any) {
  Object.keys(data.data).forEach((key) => (data.data[key] == null) && delete data.data[key]);
  fotorSDK("shareWithInfo", JSON.stringify(data));
}

/**
 * GoArt SDK 打开自定义的文件选择器
 * @param {Object} data {
  "accept": "humanface/*", // "humanface/*" 表示人脸照片
  "multiple": false,//是否多选
  "humanface_range": { //accept 为 "humanface/*" 时使用这字端
     "start": 30,
     "end": 30,
  }
} */
export function goartOpenFileChooser(data: any) {

  const appVersion = getGoArtClientInfo().appVersion || "1.0.0";
  const goartVersionLt3_4_9 = isInGoArtAppBrower() && compareVersion(appVersion, "3.4.9") == -1

  // iOS GoArtv3.4.9 之前，少写了个 * 号，单独处理
  if (data.accept === "humanface/*" && goartVersionLt3_4_9) {
    data.accept = "humanface/";
  }

  /*
    选择图片后会回调
    window.AI_NativeFileSelected({
      "base64": ["..."]
    })
  */
  goArtSDK("AI_openFileChooser", JSON.stringify(data));
}

/**
 * Fotor SDK 打开自定义的文件选择器
 * @param {Object} data {
  "accept": "humanface/*", // "humanface/*" 表示人脸照片
  "multiple": false,//是否多选
  "humanface_range": { //accept 为 "humanface/*" 时使用这字端
     "start": 30,
     "end": 30,
  }
} */
export function fotorOpenFileChooser(data: any) {

  const appVersion = getClientInfo().appVersion || "1.0.0";
  const fotorVersionLt10_4_15 = isInAppBrower() && compareVersion(appVersion, "10.4.15") == -1

  // Fotor 10.4.15之前，少写了个 * 号，单独处理
  if (data.accept === "humanface/*" && fotorVersionLt10_4_15) {
    data.accept = "humanface/"
  }

  /*
    选择图片后会回调
    window.FT_NativeFileSelected({
      "base64": ["..."]
    })
  */
  fotorSDK("FT_openFileChooser", JSON.stringify(data));
}

/**
 * GoArt SDK 打开订阅页
} */
export function goartOpenSubscription() {
  /**
   * 订阅成功后会回调
    window.AI_SubscriptionSuccess()
   */
  goArtSDK("AI_openSubscription");
}

/**
 * Fotor SDK 打开订阅页
} */
export function fotorOpenSubscription() {
  /**
   * 订阅成功后会回调
    window.FT_SubscriptionSuccess()
   */
  fotorSDK("FT_openSubscription",);
}


// shareImageUrls;//分享图片的地址（返回数组，单图分享取数组第一张作品，个人中心分享返回用户作品前9张）
// userAvatarUrl;//用户头像地址    （个人中心）
// userName;//用户昵称   （个人中心）
// userId;用户ID     （个人中心）
// communityID:帖子id    （社区作品）
// textToImagePromt;//文生图描述    （文生图需要）
// shareOriginalImageUrl;//原图地址    （图生图、社区作品需要）

export function goartShare_AI_Image(img?: string, base64?: string) {
  let data = {} as any;
  if (img) {
    data.img = img;
  }
  if (img) {
    data.base64 = base64;
  }
  goartShareWithInfo({
    type: "AI_Image",
    data: {
      img,
      base64
    }
  })
}

export function goartShare_AI_Community_Work_Detail(resultUrl: string, originalUrl: string, communityID: string, text: string) {
  goartShareWithInfo({
    type: "AI_Community_Work_Detail",
    data: {
      shareImageUrls: [resultUrl],
      shareOriginalImageUrl: originalUrl,
      communityID,
      textToImagePromt: text,
    }
  })
}

export function goartShare_AI_Community_User_Center(imgs: string[], userAvatarUrl: string, userName: string, userId: string) {
  goartShareWithInfo({
    type: "AI_Community_User_Center",
    data: {
      shareImageUrls: imgs,
      userAvatarUrl,
      userName,
      userId
    }
  })
}

export function goartShare_AI_Image_From_Text(resultUrl: string, text: string) {
  goartShareWithInfo({
    type: "AI_Image_From_Text",
    data: {
      shareImageUrls: [resultUrl],
      textToImagePromt: text,
    }
  })
}

export function goartShare_AI_Image_From_Image(resultUrl: string, originalUrl: string) {
  goartShareWithInfo({
    type: "AI_Image_From_Image",
    data: {
      shareImageUrls: [resultUrl],
      shareOriginalImageUrl: originalUrl,
    }
  })
}

/**
 * GoArt SDK 通用下载
 * @param {Object} data {
  "type": 'img', // img下载图片
  "data": {
    "url":"",
    "base64":""
  }
}
 */
export function goartNativeDownload(data: any) {
  Object.keys(data.data).forEach((key) => (data.data[key] === undefined || data.data[key] === null) && delete data.data[key]);
  goArtSDK("AI_download", JSON.stringify(data));
}
/**
 * Fotor SDK 通用下载
 * @param {Object} data {
  "type": 'img', // img下载图片
  "data": {
    "url":"",
    "base64":""
  }
}
 */
export function fotorNativeDownload(data: any) {
  Object.keys(data.data).forEach((key) => (data.data[key] === undefined || data.data[key] === null) && delete data.data[key]);
  fotorSDK("FT_download", JSON.stringify(data));
}


/**
 * Fotor SDK 通用loading
 * @param str  loading文字
 */
export function fotorNativeShowLoading(str: string) {
  fotorSDK("fotorShowLoadingDialog", str);
}

/**
 * Fotor SDK  关闭loading
 * @param str  loading文字
 */
export function fotorNativeHideLoading() {
  fotorSDK("fotorHideLoadingDialog");
}


/**
 * Fotor SDK 通用loading
 * @param str  loading文字
 */
export function fotorNativeShowMessageBox(title: string) {
  fotorSDK("fotorSdkMessageBox", title);
}




/**
 * Fotor SDK  toast
 * @param str  toast
 */
export function fotorSdkToast(str: string) {
  fotorSDK("fotorSdkToast", str);
}

/**
 * Fotor SDK  toast
 * @param str  toast
 */
export function fotorSdkResetLogin() {
  fotorSDK("fotorSdkResetLogin");
}









//获取浏览器版本
export function getBroswerVersion() {
  let sys: any = {};
  let ua = navigator.userAgent.toLowerCase();
  console.log('=======>ua', ua)
  let s;
  (s = ua.match(/edge\/([\d.]+)/)) ? sys.edge = s[1] :
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? sys.ie = s[1] :
      (s = ua.match(/msie ([\d.]+)/)) ? sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? sys.firefox = s[1] :
          (s = ua.match(/chrome\/([\d.]+)/)) ? sys.chrome = s[1] :
            (s = ua.match(/opera.([\d.]+)/)) ? sys.opera = s[1] :
              (s = ua.match(/version\/([\d.]+).*safari/)) ? sys.safari = s[1] : 0;

  if (sys.edge) return { broswer: "Edge", version: sys.edge };
  if (sys.ie) return { broswer: "IE", version: sys.ie };
  if (sys.firefox) return { broswer: "Firefox", version: sys.firefox };
  if (sys.chrome) return { broswer: "Chrome", version: sys.chrome };
  if (sys.opera) return { broswer: "Opera", version: sys.opera };
  if (sys.safari) return { broswer: "Safari", version: sys.safari };

  return { broswer: "", version: "0" };
}

// 版本比较
export function compareVersion(v1o: string, v2o: string) {
  const v1 = v1o.split(".");
  const v2 = v2o.split(".");
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push("0");
  }
  while (v2.length < len) {
    v2.push("0");
  }
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}

/*
 * 更新分享配置
 * app: vue this实列，必传
 * title: 分享标题
 * desc: 分享描述
 * shareImgUrl: 分享icon链接
 * */
interface IUpdateShareConfigParams {
  title?: string;
  desc?: string;
  shareImgUrl?: string;
  shareUrl?: string;
}
export async function updateShareConfig(
  app: { $t: Function;[propName: string]: any },
  { title, desc, shareImgUrl, shareUrl }: IUpdateShareConfigParams
) {
  let nowUrl = window.location.href;
  nowUrl = encodeURIComponent(nowUrl);
  console.log("klkl");
  const result = await wxShareConfig(nowUrl);
  const jsconfig = result.data;
  shareUrl = shareUrl || window.location.href;
  shareImgUrl = shareImgUrl || getHref() + "/mobile/wechat/img/share_icon.png";
  title = title || app.$t("pageHead.title");
  desc = desc || app.$t("pageHead.desc");
  window.setShareInfo({
    title,
    summary: desc,
    pic: shareImgUrl,
    url: shareUrl,
    WXconfig: {
      swapTitleInWX: false,
      appId: jsconfig.appId,
      timestamp: jsconfig.timestamp,
      nonceStr: jsconfig.nonceStr,
      signature: jsconfig.signature
    }
  });
}

export function getBrowserLanguage() {
  if (process.server) return "en";
  const lang = navigator.language;
  return lang.toLowerCase();
}


export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}

const recaptchaCode = '6Lfa4BwcAAAAACLfJjPNBjn-aOkRR-P2EEXL9Sdm'
/**
 * 创建谷歌人机验证recaptcha
 * CheckBox
 */
export const createRecaptcha = (onload: () => void) => {
  const scriptRecaptcha = document.createElement('script')
  scriptRecaptcha.type = 'text/javascript'
  scriptRecaptcha.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit`
  scriptRecaptcha.async = true
  scriptRecaptcha.defer = true
  scriptRecaptcha.onload = onload
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      onload()
    }
  }
  document.head.append(scriptRecaptcha)
}

export const renderRecaptcha = (domId: string, verifyCallback: (token: string) => {}) => {
  if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
    window.grecaptcha.enterprise.render(domId, {
      sitekey: recaptchaCode,
      // size: "compact",
      theme: 'dark',
      callback: verifyCallback
    })
  }
}

/**
 * 此方法用于webview 打开 app link  过渡处理
 * @param app fotor,terabox 网站平台
 * @param platform android,ios 系统平台
 * @param position banner,sidebar 入口位置
 *
 */
export function openStroeLink(app: string, platform: string, position: string, test: boolean) {
  const os = platform.trim().toLocaleLowerCase()

  // 添加神策测试
  if (test) {
    if (app === 'fotor') {
      // fotor
      if (os === 'ios') {
        const deeplink = position === 'banner' ? 'https://datasink-sa.fotor.com.cn/r/W2' : 'https://datasink-sa.fotor.com.cn/r/j2';
        // ios
        location.href = deeplink;
      } else {
        const deeplink = position === 'banner' ? 'https://datasink-sa.fotor.com.cn/r/12' : 'https://datasink-sa.fotor.com.cn/r/32';
        location.href = deeplink

        // window.open('market://details?id=com.everimaging.photoeffectstudio')
        // android
        // openHideLink(deeplink, () => {
        //   // 标注原因：因为神策不支持deeplink localtion进行重定向
        //   // console.log('打开成功');
        //   // location.href = 'market://details?id=com.everimaging.photoeffectstudio'
        //   window.open('market://details?id=com.everimaging.photoeffectstudio')
        // })
      }

    } else {
      // teraBox
      const deeplink = 'https://dubox.onelink.me/yqcq?pid=fotor&c=fotor';
      if (os === 'ios') {
        // ios
        openHideLink(deeplink, () => {
          // 标注原因：因为fotor webview不支持https://apps.apple.com/SG/app/id1509453185?mt=8这种方式跳转
          location.href = 'https://itunes.apple.com/sg/app/id1509453185';
        })
      } else {
        // android
        location.href = deeplink
      }

    }
    return
  }

  if (app === 'fotor') {
    // fotor
    if (os === 'ios') {
      const deeplink = position === 'banner' ? 'https://datasink-sa.fotor.com.cn/r/6X' : 'https://datasink-sa.fotor.com.cn/r/pX';
      // ios
      location.href = deeplink;
    } else {
      const deeplink = position === 'banner' ? 'https://datasink-sa.fotor.com.cn/r/x2' : 'https://datasink-sa.fotor.com.cn/r/a2';
      // android
      openHideLink(deeplink, () => {
        // 标注原因：因为神策不支持deeplink localtion进行重定向
        // console.log('打开成功');
        location.href = 'market://details?id=com.everimaging.photoeffectstudio'
      })
    }

  } else {
    // teraBox
    const deeplink = 'https://dubox.onelink.me/yqcq?pid=fotor&c=fotor';
    if (os === 'ios') {
      // ios
      openHideLink(deeplink, () => {
        // 标注原因：因为fotor webview不支持https://apps.apple.com/SG/app/id1509453185?mt=8这种方式跳转
        location.href = 'https://itunes.apple.com/sg/app/id1509453185';
      })
    } else {
      // android
      location.href = deeplink
    }

  }


}

/**
* 将内容拷贝到剪切板中
*
* @param copyText  需要拷贝的内容
* @param elmId  临时插入domID
*/
export function copyContent(message: string, elmId: string) { // text: 要复制的内容， callback: 回调

  const input = document.createElement("input");

  input.value = message;

  document.getElementById(elmId)!.appendChild(input);

  input.select();

  input.setSelectionRange(0, input.value.length);

  document.execCommand('Copy');

  document.getElementById(elmId)!.removeChild(input);

}

/**
* 打开一个隐藏链接，一般用于触发统计相关链接
*
* @param url 需要打开的链接
* @param callback 回调
*/
function openHideLink(url: string, callback: () => void) {
  const el = document.createElement('iframe');
  el.src = url
  el.style.display = 'none'
  el.onload = callback
  document.body.append(el)
}

/*
*  解决IOS 拖动弹性上下滑动，副作用就是不能滚动
*/
export function iosDisableScrolling() {
  const { isAndroid } = getBrowser();

  if (!isAndroid) {
    document.body.addEventListener(
      "touchmove",
      e => {
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );
  }
}

//一些公共的 code 对应 msg【TODO：未做多语言】
export function commonCodeMsg() {
  const msgs: any = {
    "403": "You are not logged in or your login has expired.",//未登录或登陆过期
    "fail": "Network or server error, please try again",//网络或服务器错误，请稍后再试
  }
  msgs["114"] = msgs["403"];
  return msgs;
}


export function getHost() {
  return location.protocol + '//' + location.host
}

const fotorAdjustLinkPrefixEnv: { [key: string]: any } = {
  development: "https://app.adjust.com/sp92lsw_filvaq8",
  production: "https://app.adjust.com/5t0c3sp_mh8zuw6",
};

const goartAdjustLinkPrefixEnv: { [key: string]: any } = {
  development: "https://app.adjust.com/192l5wmc_19o399u1",
  production: "https://app.adjust.com/19ty85ew_19aqneir",
};

const clipflyAdjustLinkPrefixEnv: { [key: string]: any } = {
  Film_share_H5: {
    ios: "https://app.adjust.com/1oypmjfi",
    android:'"https://app.adjust.com/1o5ga2y5'
  },
  Download_invite_friend:{
    ios: "https://app.adjust.com/1pdb1tk5",
    android:'https://app.adjust.com/1pwinfjq'
  },
  Song_share_H5:{
    ios: "https://app.adjust.com/1rg7nu1g_1rs1zaxz",
    android:'https://app.adjust.com/1rg7nu1g_1rs1zaxz'
  }
};

function getFotorAdjustLinkPrefix() {
  return fotorAdjustLinkPrefixEnv[isProd ? 'production' : 'development']
}

function getGoArtAdjustLinkPrefix() {
  return goartAdjustLinkPrefixEnv[isProd ? 'production' : 'development'];
}

function getClipflyAdjustLinkPrefix(urlType: string) {
  const { isAndroid } = getBrowser();
  const platform = isAndroid? 'android':'ios'
  return clipflyAdjustLinkPrefixEnv[urlType][platform];
}

export const createAdjustDeepLink = (
  {
    app_link = getFotorAdjustLinkPrefix(),
    campaign = "",
    adgroup = "",
    creative = "",
    deep_link = "",
    redirect_ios = "",
    redirect_android = "",
    theme = "",
    channel = ""
  },
) => {
  const params = [];
  campaign && params.push(`campaign=${encodeURIComponent(campaign)}`);
  adgroup && params.push(`adgroup=${encodeURIComponent(adgroup)}`);
  creative && params.push(`creative=${encodeURIComponent(creative)}`);
  theme && params.push(`theme=${encodeURIComponent(theme)}`);
  channel && params.push(`channel=${encodeURIComponent(channel)}`);
  deep_link && params.push(`deep_link=${encodeURIComponent(deep_link)}`);
  redirect_ios && params.push(`redirect_ios=${encodeURIComponent(redirect_ios)}`);
  redirect_android &&
    params.push(`redirect_android=${encodeURIComponent(redirect_android)}`);
  return app_link + "?" + params.join("&");
};

/* openInApp 调用追踪
label：
  position：按钮位置（一般取adgroup）
  url：页面路径
  type：取值为adjust、sa
  key：type为sa时取链接后两位，type为adjust取adjust
*/
export function trackOpenInApp(label: {
  position: string;
  url: string;
  type: "adjust" | "sa";
  key: string;
}) {
  // console.log('追踪 open in app', label);
  sensorsTrack("fotor_web$event$open_app_visit", label);
}

const fotorSaLinkConfig = {
  ios: {
    general_all: "https://datasink-sa.fotor.com.cn/r/Eu", //所有通用
  },
  android: {
    general_all: "https://datasink-sa.fotor.com.cn/r/7u",
  }
}
//使用神策渠道链接打开 Fotor app
export function openInFotorAppBySaLink({
  adgroup,
  campaign,
}: {
  adgroup: string,
  campaign: string,
}) {
  const link = fotorSaLinkConfig[getBrowser().isiOS ? 'ios' : 'android'].general_all;

  trackOpenInApp({
    position: adgroup,
    url: campaign,
    type: "sa",
    key: link.slice(-2)
  });

  location.href = link;
}

type AdjustCommonParams = {
  adgroup: string,
  campaign: string,
  schema?: string,
  urlType?: string
}

//使用  Adjust 链接打开 Fotor app
export function openInFotorAppByAdjustLink({
  adgroup,
  campaign,
  schema,
}: AdjustCommonParams) {
  trackOpenInApp({ position: adgroup, url: campaign, type: "adjust", key: "adjust" });
  location.href = createAdjustDeepLink({
    campaign,
    adgroup,
    deep_link: schema,
  });
}

//使用  Adjust 链接打开 Fotor app
export function openInClipFlyAppByAdjustLink({
  urlType,
  adgroup,
  campaign,
  schema,
}: AdjustCommonParams) {
  location.href = createAdjustDeepLink({
    app_link: getClipflyAdjustLinkPrefix(urlType || "Download_invite_friend"),
    campaign,
    adgroup,
    deep_link: schema,
  });
}



//使用  Adjust 链接打开 GoArt App
export function openInGoArtAppByAdjustLink({
  adgroup,
  campaign,
  schema,
}: AdjustCommonParams) {
  trackOpenInApp({ position: adgroup, url: campaign, type: "adjust", key: "adjust" });
  location.href = createAdjustDeepLink({
    app_link: getGoArtAdjustLinkPrefix(),
    campaign,
    adgroup,
    deep_link: schema,
  });
}

export function currentHost() {
  return process.env.APP_ENV === "development" ? "http://test-nuls-mobile.fotor.com" : "http://nuls-mobile.fotor.com"
}

export function currentClipFlyHost() {
  return process.env.APP_ENV === "development" ? "https://test-mobile.clipfly.ai/" : "https://mobile.clipfly.ai/"
}


function isMobiDomain() {
  return process.client && [
    'nuls-mobile.fotor.mobi',
    'test-nuls-mobile.fotor.mobi',
    // 'localhost:3000',
  ].includes(location.host)
}
export function GET_BASE_URL() {
  return isMobiDomain() ? process.env.BASE_URL_MOBI : process.env.BASE_URL;
}

export function GET_GOART_BASE_URL() {
  return isMobiDomain() ? process.env.GOART_BASE_URL_MOBI : process.env.GOART_BASE_URL;
}

export function GET_FOTOR_BASE_URL() {
  return isMobiDomain() ? process.env.FOTOR_BASE_URL_MOBI : process.env.FOTOR_BASE_URL;
}

function getMonthName(date: Date, locale: string): string {
  return new Intl.DateTimeFormat(locale, { month: 'short' }).format(date);
}

export function formatDateWithLanguage(milliseconds: number, format: string, selectedLanguageCode: string) {
  const languages = [
    {
      language: "简体中文",
      code: "zh"
    },
    {
      language: "英文",
      code: "en"
    },
    {
      language: "繁体中文",
      code: "tw"
    },
    {
      language: "日文",
      code: "ja"
    },
    {
      language: "法语",
      code: "fr"
    },
    {
      language: "葡萄牙语",
      code: "pt"
    },
    {
      language: "西班牙语",
      code: "es"
    },
    {
      language: "德语",
      code: "de"
    },
    {
      language: "俄语",
      code: "ru"
    },
    {
      language: "意大利语",
      code: "it"
    },
    {
      language: "土耳其语",
      code: "tr"
    },
    {
      language: "泰语",
      code: "th"
    },
    {
      language: "印度尼西亚语",
      code: "id"
    },
    {
      language: "越南语",
      code: "vi"
    },
    {
      language: "韩语",
      code: "ko"
    }
  ];
  if (!languages.find(lang => lang.code === selectedLanguageCode)) {
    console.warn(`Unsupported language code: ${selectedLanguageCode}`);
    selectedLanguageCode = 'en'; // 如果找不到对应的语言代码，默认使用英文
  }

  const locale = `${selectedLanguageCode}-u-nu-latn`; // 使用拉丁数字，确保数字格式一致
  const date = new Date(milliseconds);
  const monthName = getMonthName(date, locale);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  switch (format) {
    case 'dd/MM/yyyy':
      return `${day}/${month}/${year}`;
    case 'MMM dd, yyyy':
      return `${monthName} ${day}, ${year}`;
    case 'dd.MMM.yyyy':
      return `${day}.${monthName}.${year}`;
    case 'dd. MMM yyyy':
      return `${day}. ${monthName} ${year}`;
    case 'dd MMM, yyyy':
      return `${day} ${monthName}, ${year}`;
    case 'yyyy年MM月dd日':
      return `${year}年${month}月${day}日`;
    default:
      return 'Invalid format';
  }
}

export const loadScript = (src: string, options?: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    if (options) {
      Object.keys(options).forEach(key => {
        script.setAttribute(key, options[key])
      })
    }
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  })
}

//加载移动端公共脚本
export const loadMobileCommonScript = (): Promise<any> => {
  // console.log('=======>移动脚本加载', (!getBrowser().isMobile))
  // if (!getBrowser().isMobile) {
  //   return Promise.reject();
  // }
  if (window["mobileCommon"]) {
    return Promise.resolve();
  } else {
    console.log('=======>process.env.mobileCommon_SDK!', process.env.mobileCommon_SDK!)
    return loadScript(process.env.mobileCommon_SDK!);
  }
}

// 移动端公共组件库SDK载入完成后执行回调

export const mobileCommonSdkLoaded = (callback: (sdk: any) => void) => {
  //如果已载入立即执行
  if (window.mobileCommon) {
    callback && callback(window.mobileCommon);
    return () => { };
  }
  function stop() {
    //移除监听
    window.removeEventListener('mobile_common_sdk_loaded', loadedHandle);
  }
  function loadedHandle() {
    callback && callback(window.mobileCommon);
    stop();
  }
  //创建 SDK载入完成事件监听
  window.addEventListener('mobile_common_sdk_loaded', loadedHandle);
  return stop;
}


export const getRandomElements = (arr: any[], count: number): any[] => {
  if (count < 0) {
    throw new Error("请求的元素数量必须是非负数");
  }

  if (count > arr.length) {
    throw new Error(`请求的元素数量 ${count} 超过数组长度 ${arr.length}`);
  }

  const result: any[] = [];
  const indices = new Set<number>();
  while (indices.size < count) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    indices.add(randomIndex);
  }
  indices.forEach(index => {
    result.push(arr[index]);
  });

  return result;
}


/**
 * 获取i18n的值
 * @param app
 * @param k
 * @returns 在fetchData 中使用 渲染前获取正确的head值
 */
export const getI18n = (app: any, k: string) => {
  const currentLang = app.$pageLanguage;
  let data = app.i18n.messages[currentLang];
  if (!data[k]) {
    const defaultLang = app.i18n.fallbackLocale;
    data = app.i18n.messages[defaultLang];
    console.warn(`当前语言 ${currentLang} 下的 "${k}" 不存在，切换到默认语言 ${defaultLang} 去读取`)
  }
  return data[k];
}